function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M83.4 24.6C37.4 24.6 0 61.9 0 108h166.9c0-46-37.4-83.4-83.5-83.4Z",
  fill: "#C0EFFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m43.2 100-.7 8h23.9c.2-4.9-11.7-4.6-12-8.7v-3A46 46 0 0 0 43 97l.3 3ZM13.4 95.5l-3.1 7.6 12 4.9h11.4c.4-2.2-2.6-3.7-6.6-4.3-3.8-.6-3.4-3.5-3-4.5L22 96c-3.4.8-5.4-2.9-8.6-.6Z",
  fill: "#4D4D4D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M66.8 108H42l.2-2c0-.5.4-.8.9-.8l22.4 1.8c.6 0 .8.1 1.2.4v.4l.1.2ZM34 107.8c.1 0 0 .2 0 .2H22.4c-.8 0-1.7-.1-2.5-.3l-11-3 .7-1.6c.3-.7.4-1 1-.9L20 106c1 .4 2 .6 3.2.7l9.5.7c.6 0 1 0 1.4.5Z",
  fill: "#0D0D0D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m74.3 2.6.8.7h.2l2.3.4c.7.2 1.8.7 2 3l1.6 22.4h3.2l-1-26.5h-9.1Z",
  fill: "#238ED7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M83 108a16.8 16.8 0 0 1-17-16.5 16.8 16.8 0 0 1 16.5-17.4 16.8 16.8 0 0 1 17.4 16.5 16.8 16.8 0 0 1-17 17.4ZM83 79h-.4A11.9 11.9 0 0 0 71 91.4 11.9 11.9 0 0 0 83.3 103a11.9 11.9 0 0 0 11.6-12.3 11.9 11.9 0 0 0-12-11.6Z",
  fill: "#000"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M83 96.2A5.2 5.2 0 1 0 83 86a5.2 5.2 0 0 0 0 10.3Z",
  fill: "#0E3163"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m116.2 96.5.3-.6A3 3 0 0 0 115 92l-11.4-5.2a3 3 0 0 0-3.9 1.4l-.3.7a3 3 0 0 0 1.4 3.8l11.5 5.3a3 3 0 0 0 3.9-1.5Z",
  fill: "#2368CC"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M150.3 108a16.8 16.8 0 0 1-17-16.5 16.8 16.8 0 0 1 16.5-17.4 16.8 16.8 0 0 1 17.4 16.5 16.8 16.8 0 0 1-17 17.4Zm0-28.9h-.4a11.9 11.9 0 0 0-11.6 12.3 11.9 11.9 0 0 0 12.3 11.6 11.9 11.9 0 0 0 11.6-12.3 11.9 11.9 0 0 0-12-11.6Z",
  fill: "#000"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M150.3 96.2a5.2 5.2 0 1 0 0-10.3 5.2 5.2 0 0 0 0 10.3Z",
  fill: "#0E3163"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M122 85.4a6 6 0 0 0-4-3.4h-.2a1.4 1.4 0 1 0-.7 2.7h.2a3.2 3.2 0 0 1 2 4.7l-2.5 4.6c-.6 1.2-2 1.8-3.3 1.6L63.7 81.8a4.1 4.1 0 1 0-1.8 8l51.1 8.5a6 6 0 0 0 6.2-3l2.5-4.6a6 6 0 0 0 .2-5.3ZM132.4 92.7a3 3 0 0 1-3-2.9 19.7 19.7 0 0 1 19.3-20.3c5-.2 9.8 1.5 13.6 4.8a3 3 0 1 1-3.8 4.4 14 14 0 0 0-23.2 11 3 3 0 0 1-2.8 3h-.1Z",
  fill: "#1A4E99"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m135 70-18.3 14.5c-4.2 2.9-10.5 1.7-12.8-2.3a23.7 23.7 0 0 0-20.2-11c-5-.3-10.1 1-14.3 3.3-1.8 1-4-.5-3.2-2.1l4.4-13.6 64.2 5.8.2 5.4Z",
  fill: "#0D0D0D"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m147.6 61-.7-11.1c0-1-1-1.7-2-1.5-4 .7-7 3.8-7 7.6 0 .6 0 1.7.3 2.5H136a7.6 7.6 0 0 0-7.5-6.4l-41.8 5.3-17-.4c-.6 0-3 1-5.5 2.1-2.3 1-2.3 4.1 0 5l6.4 2.4c3.7 2 8 2.9 12.5 2.6l10.2-.5c5-.3 9.7.6 14 2.4l6.4 3.7c5 2.8 11.3 3 16.5 1 3.4-1.4 6-4.2 7-7.6l1.3-5 7.5-.5c.9 0 1.6-.8 1.6-1.7Z",
  fill: "#1A4E99"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M150.3 90.1c-.7 0-1.4-.4-1.7-1l-19.7-41.6a1.9 1.9 0 1 1 3.3-1.7L152 87.5a1.9 1.9 0 0 1-1.7 2.6ZM131.4 41.6a4.1 4.1 0 1 0 2.8-7.8l-2.8 7.8Z",
  fill: "#0D0D0D"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M132.5 52a.7.7 0 0 1-.5-1.2 7 7 0 0 0 2.2-5.3l-.2-4.9a.8.8 0 0 1 1.5 0l.2 4.9c0 2.4-1 4.7-2.7 6.4l-.5.2ZM131.3 48.5l-2 1.2A2.2 2.2 0 0 1 127 46l2-1.2a2.2 2.2 0 0 1 2.2 3.7Z",
  fill: "#0D0D0D"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M61.4 29.1A3.5 3.5 0 0 0 58 32l-.9 4.7h-2.4l-1.2 19c0 1.6 1.3 2.9 2.8 2.9h28c1.6 0 2.9-1.3 2.9-3l-2.7-26.5h-23ZM74.3 2.6 79 3c1.6.1 3 1.5 3.1 3.2L84.4 29l1-.2c1.8-.4 3-2 2.9-3.8l-2-21.9A3.6 3.6 0 0 0 82.5 0L74 .2l.3 2.4Z",
  fill: "#38B8E0"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5 35.3v-2.2l1.4 2.2h-1.4Z",
  fill: "#CE3D71"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M64.6 35.3H61l-1.4-2.2v-2h1.4l3.7 4.2Z",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M68.4 35.3h-3.8L61 31h3.7l3.8 4.3Z",
  fill: "#CE3D71"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M72.1 35.3h-3.7L64.6 31h3.8l3.7 4.3Z",
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M75.9 35.3H72L68.4 31H72l3.8 4.3Z",
  fill: "#CE3D71"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M79.6 35.3h-3.7L72 31H76l3.7 4.3Z",
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M83.4 35.3h-3.8L75.9 31h3.7l3.8 4.3Z",
  fill: "#CE3D71"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M84.3 35.3h-1L79.7 31h3.8l.5 1 .4 3.3Z",
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "m84 32-1-1h.8l.1 1Z",
  fill: "#CE3D71"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M74.1 42.5a5.6 5.6 0 0 0-.6-.3s-1.4-1-2-1.2c-.5-.2-1.5-.7-2.6-.7-.8 0-1.3.2-1.5.2-.2 0-.3.1 0 .2l.7.5 1.6.8 1.5.1c.7 0 1 .3 1.1.4-.1-.1-.6-.3-1.3-.3h-1.4a13 13 0 0 1-1.7-.7 4 4 0 0 0-.5.1c-.1.1-.3.2 0 .3.1 0 1.8.7 2.3.7h1.4c.6-.2 1 0 1 .2-.2.3-.3.7-.3 1l-3.6-.7c-1-.1-2.2.7-2.3 1.6 0 .6 0 1.1.4 1.6l1 1v.5c0 .2.2.4.3.4l1.5.4 2 .7.1-.2c0-.2-.1-.6-.6-.7l-1-.3.1-.2.5-.6c.4-.9-.1-1.7-.1-1.7l.5 1c.1.7-.4 1.3-.4 1.3l.3.1 2.2-2.2.6-.3 1.4-.6.4-.6.1-.3-.3-.5s-.4-.7-.8-1M68.3 48.7c-.1.1-.2.3 0 .4l.7-.2-.5-.2h-.2Z",
  fill: "#fff"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "m24.7 100.7-12.5-5.3A461.2 461.2 0 0 0 23 68.7c1.6-6.7 6-29.2 6-29.5l13.3 2.6c-.2 1-4.5 23-6.2 30.2-.2.9-.8 3-6.2 16.3l-5.2 12.4Z",
  fill: "#0E3163"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2 101.2c-.5-2.7-4.7-25.3-5.5-32.2-1.1-2-4.7-7.2-7-10.5l-4.9-7.4c-2.3-3.6-3-5.1-3.2-6.8a15.6 15.6 0 0 1 5.6-14.6 20 20 0 0 1 6.5-3.6l4 13V39c-.2 0-1.2.5-2 1.2-.5.5-.8 1-.8 1.5 1 1.9 4 6.2 6 9.2 7.4 10.8 8.8 13.2 9 15.8.4 3.6 3.6 21.1 5.6 32l-13.3 2.5Z",
  fill: "#1B4D89"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "m42.9 23.8 5.4 11.5-1.7.9-4-.6.3-11.8Z",
  fill: "#0D0D0D"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M53.2 41.8c2.5-.7 5.3-2.4 6.6-3.9.7-.9-.2-2.3-3.2-1.4-1.3.4-2.7.4-5.1 1.3-1 .4-1 4.7 1.7 4Z",
  fill: "#8DE1FF"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "m42.4 41.4-20-2.6a.8.8 0 0 1-.7-.8l2.1-13.7c.1-3.3 3.5-6 6.9-5.9l3.8.2A10 10 0 0 1 44 28.8v.1l-.7 11.7c0 .5-.4.8-.9.8Z",
  fill: "#0D0D0D"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "m22.2 34.7-.3 2 6 .9.2-2-6-.9ZM22.6 31.8l-.3 2 6 .8.3-2-6-.8Z",
  fill: "#A0E0CD"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5 25.3h-14c-.6 0-1.1.5-1.1 1.2v9.2c0 .6.5 1.1 1 1.1h14.1c.6 0 1.1-.5 1.1-1v-9.3c0-.7-.5-1.2-1-1.2Z",
  fill: "#E6E6E6"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M60 36.8v-5c0-.2 0-.3-.2-.3h-4.1c-.2 0-.2.1-.2.2v5.1H60Z",
  fill: "#fff"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M61.7 18.4h-14c-.6 0-1.1.5-1.1 1.1v4.7c0 .6.5 1.1 1 1.1h14.1c.6 0 1.1-.5 1.1-1v-4.8c0-.6-.5-1.1-1-1.1Z",
  fill: "#999"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M53.5 25.3v-5c0-.2 0-.3-.2-.3h-4.1l-.2.2v5.1h4.5Z",
  fill: "#fff"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M61.3 15.6H49.9a1 1 0 0 0-1 .9v1c0 .5.5.9 1 .9h11.4c.5 0 1-.4 1-1v-1c0-.4-.5-.8-1-.8Z",
  fill: "#CCC"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M60 18.4v-2c0-.1 0-.2-.2-.2h-3v2.2H60Z",
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M57.3 16.7H57V18h.2v-1.3ZM57.7 16.7h-.2V18h.2v-1.3ZM58 16.7V18v-1.3ZM58.4 16.7h-.1V18h.1v-1.3ZM58.8 16.7h-.1V18h.1v-1.3ZM59.2 16.7h-.1V18h.1v-1.3ZM59.6 16.7h-.2V18h.2v-1.3ZM49.8 22.7h-.2v2.1h.2v-2.1ZM50.3 22.7H50v2.1h.2v-2.1ZM50.8 22.7h-.2v2.1h.2v-2.1ZM51.4 22.7h-.2v2.1h.2v-2.1ZM51.9 22.7h-.2v2.1h.2v-2.1ZM52.4 22.7h-.2v2.1h.2v-2.1ZM53 22.7h-.2v2.1h.2v-2.1ZM56.2 34.2H56v2.1h.2v-2.1ZM56.8 34.2h-.2v2.1h.2v-2.1ZM57.3 34.2h-.2v2.1h.2v-2.1ZM57.8 34.2h-.2v2.1h.2v-2.1ZM58.4 34.2h-.2v2.1h.2v-2.1ZM59 34.2h-.3v2.1h.2v-2.1ZM59.4 34.2h-.1v2.1h.1v-2.1Z",
  fill: "#000"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M27 19.4s-5.3 2.6-3.4 10L26 29l1.2-9.6Z",
  fill: "#0D0D0D"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "m23 28.8-.2 2 6 .9.2-2-6-.9Z",
  fill: "#A0E0CD"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "m51.5 38.7.5-.1 3.4-2.1a1 1 0 1 0-1-1.8L50.9 37a1 1 0 0 0 .6 1.8Z",
  fill: "#8DE1FF"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "m44 42.7 8.8-.9-.1-5.1H44v6Z",
  fill: "#8DE1FF"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "m48.3 43.4-14-1.1a7.3 7.3 0 0 1-6-4.1l-5-10.6 7.5-3.6 4.8 10L49 35.2l-.7 8.2Z",
  fill: "#0D0D0D"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "m43.6 34.7-5.4-.6a1 1 0 0 1-.8-.6l-4-8.5s-1.3-3.3-4-3.3a.1.1 0 0 1 0-.3c2.9 0 4.2 3.4 4.3 3.5l4 8.5c0 .2.3.4.5.4l5.5.7v.2Z",
  fill: "#fff"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M36.8 2c-.6-.5-1.6-.5-2.3 0l-8.8 9c-.3.3-.3.8 0 1.1 5.6 5 14 5 19.6.3.5-.4.6-1.3 0-1.8l-8.5-8.5Z",
  fill: "#1A4E99"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2 8.5h-3.7v2h-.2a1 1 0 1 0-.7 2h.8V19c.2.7.7 1.3 1.5 1.3.7 0 1.3-.7 1.3-1.5V17l1 .2h.2c2 0 3.5-1.6 3.5-3.5V8.5h-3.7Z",
  fill: "#8DE1FF"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M36 9.3h-1a.6.6 0 1 0 0 1.1h1a.6.6 0 1 0 0-1ZM39.3 9.2h-.9a.6.6 0 1 0 0 1.1h.8a.6.6 0 1 0 0-1Z",
  fill: "#fff"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M36 10.4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM39.3 10.3a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
  fill: "#1D1D1B"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M34 15c.8.3 1.5.6 3.7.6 1.1 0 1.6-.3 2-.6.1 0 .3-.2.3-.4v-3.2c0-.2-.1-.2-.3-.3-1-.3-1.5-.6-2.1-.5-.8.2-3.6.4-3.6.4-.2 0-.3.1-.3.2v3.3c0 .1 0 .3.3.4Z",
  fill: "#fff"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "m33.9 11.2-1.6-.6v-.1h.1l1.5.6ZM33.8 14.8s-1.6-1.5-1.6-2.4h.1c0 .8 1.6 2.3 1.6 2.3Z",
  fill: "#fff"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M43.5 29.7v-2l-1 2.5-4.8-2a1 1 0 1 0-.9 1.7l5.5 2.5a1 1 0 0 0 .8 0l.1-.1.3-2.6Z",
  fill: "#A0E0CD"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2 24.6h-.1l-.1.3-.9 2-4.5-2a1 1 0 1 0-.8 1.9l5.5 2.4a1 1 0 0 0 1.3-.6l.7-1.7c-.2-1-.6-1.8-1-2.3Z",
  fill: "#A0E0CD"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "m41.3 29.2 1 .4.3-1-1.3.6Z",
  fill: "#A0E0CD"
});

function SvgMotoca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 167,
    height: 108,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54);
}

var ForwardRef = React.forwardRef(SvgMotoca);
export default __webpack_public_path__ + "static/media/motoca.c6856cb2.svg";
export { ForwardRef as ReactComponent };